<template>
  <div :class="{'has-logo':showLogo}">
    <logo v-if="showLogo" :collapse="isCollapse" />
    <el-scrollbar wrap-class="scrollbar-wrapper">
      <el-menu
        ref="menu"
        :default-active="activeMenu"
        :collapse="isCollapse"
        :background-color="variables.menuBg"
        :text-color="variables.menuText"
        :unique-opened="true"
        :active-text-color="variables.menuActiveText"
        :collapse-transition="false"
        mode="vertical"
      >
        <sidebar-item v-for="route in routes" :key="route.path" :item="route" :base-path="route.path" @closeSubmenu="closeSubmenu"/>
      </el-menu>
    </el-scrollbar>
  </div>
</template>

<script>
  import {mapGetters, mapState} from 'vuex'
import Logo from './Logo'
import SidebarItem from './SidebarItem'
import variables from '@/styles/variables.scss'
import { getPermissions ,getMerchantNumber} from '@/utils/auth'

export default {
  components: { SidebarItem, Logo },
  created() {
  },
  computed: {
    ...mapGetters([
      'sidebar'
    ]),
    ...mapState({
      treeNumber: state => state.common.system_constants['default.distribute.tree.hidden.merchant.number'],
    }),
    routes() {
      // return this.$router.options.routes
      // 子菜单均无权限则父菜单hidden
      const routes = this.$router.options.routes
      if(this.treeNumber===undefined){
        return false
      }
      routes.forEach(item => {
        if (item.children) {
          if(item.hiddenNumber===true){
            let treeNumber = this.treeNumber? this.treeNumber[0].code.split(','):[]
            let merchantNumber = getMerchantNumber()
            item.hidden=treeNumber.includes(merchantNumber)
          }

          const hasAuthRoute = item.children.filter(_ => {
            if (!_.hidden && _.api && _.api.some(apiUrl => getPermissions().includes(apiUrl))) {
              return true
            } else {
              if (!_.hidden && !_.api) {
                return true
              }
              _.hidden = true
            }
          })
          if (hasAuthRoute.length === 0) {
            item.hidden = true
          }
        }
      })
      return routes
    },
    activeMenu() {
      const route = this.$route
      const { meta, path } = route
      // if set path, the sidebar will highlight the path you set
      if (meta.activeMenu) {
        return meta.activeMenu
      }
      return path
    },
    showLogo() {
      return this.$store.state.settings.sidebarLogo
    },
    variables() {
      return variables
    },
    isCollapse() {
      return !this.sidebar.opened
    }
  },
  methods: {
    closeSubmenu() {
      this.$refs['menu'].close('/transactionManage')
    }
  }
}
</script>
